import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const ReviewCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(4)};

  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(3)};
  background: ${({ theme }) => theme.palette.common.white};
`;

export const ReviewQuote = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body1)};

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
  font-style: italic;
`;

export const ReviewAuthor = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;
